export const MACOS_SCAN_COMMAND = `cnspec scan local`;
